import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {EventManagerService} from "../../../core/services/event-manager.service";
import {TranslateModule} from "@ngx-translate/core";
import {NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  imports: [
    TranslateModule,
    NgForOf,
    NgIf
  ],

  standalone: true
})
export class DropdownComponent implements OnInit, OnChanges {

  @Input() options : any;
  @Input() updateVariable : any;
  @Input() menuBoxStyle : any;
  @Input() dropDawnstatus : boolean = false;


  @Output()callback = new EventEmitter();
  // this.callback.emit()
  openDropDawnOptions: any

  constructor(private eventManagerService: EventManagerService,) { }

  ngOnInit(): void {
    this.openDropDawnOptions = this.dropDawnstatus
    this.eventManagerService.closeDropDawnOptionsEmitter.subscribe((data:any)=>{
      this.openDropDawnOptions = false
    })

  }



  // onClick($event: any) {
  //   if (!this._eref.nativeElement.contains($event.target) && this.show){
  //     customSetTimeout(()=>{
  //       this.show = false;
  //       //this.eventManager.menuTrigger.emit(-1);
  //     },1)
  //   }
  //
  // }
  toggleDropDawnOptions(){
    if(!this.openDropDawnOptions){
      this.eventManagerService.closeDropDawnOptions()
    }
    this.openDropDawnOptions = !this.openDropDawnOptions
  }

  select(option: any) {
    this.callback.emit(option)
  }
  ngOnChanges(changes:SimpleChanges) {
    this.openDropDawnOptions = this.dropDawnstatus
    if(changes['options']){
      this.options = changes['options'].currentValue
    }
  }
}
